import { MaterialSymbol } from '@nimbalyst/runtime-source/ui/icons/MaterialSymbol';

/**
 * `MaterialSymbol` renders the icon name as a ligature in ordinary text, so a
 * button that pairs an icon with a label announces "person_add Invite members".
 * The console's previous inline `<span class="material-symbols-outlined">`
 * carried `aria-hidden`; wrapping keeps that without forking the shared
 * component, which the desktop renders the same way everywhere.
 *
 * Only for icons that repeat something already written next to them. An
 * icon-only control still needs its own `aria-label` on the control itself.
 */
export function DecorativeIcon({ icon, size = 16, className }: {
  icon: string;
  size?: number;
  className?: string;
}) {
  return (
    <span aria-hidden="true" className="inline-flex items-center">
      <MaterialSymbol icon={icon} size={size} className={className} />
    </span>
  );
}
